export class HisUidService {
    private static counter = 0;

    static get( prefix?: string, postfix?: string ): string {
        let radix = 36;
        let now = Date.now().toString( radix );

        HisUidService.counter++;
        let counter = HisUidService.counter.toString( radix );

        let id = now + counter;

        if ( prefix ) {
            id = prefix + id;
        }
        if ( postfix ) {
            id = id + postfix;
        }

        return id;
    }
}
